__turbopack_context__.v({
  "allergensBody": "Nutrition-module-scss-module__QTl3MW__allergensBody",
  "allergensHeading": "Nutrition-module-scss-module__QTl3MW__allergensHeading",
  "fade-in": "Nutrition-module-scss-module__QTl3MW__fade-in",
  "icon": "Nutrition-module-scss-module__QTl3MW__icon",
  "indent": "Nutrition-module-scss-module__QTl3MW__indent",
  "inner": "Nutrition-module-scss-module__QTl3MW__inner",
  "pdv": "Nutrition-module-scss-module__QTl3MW__pdv",
  "root": "Nutrition-module-scss-module__QTl3MW__root",
  "separator": "Nutrition-module-scss-module__QTl3MW__separator",
  "servings": "Nutrition-module-scss-module__QTl3MW__servings",
});
